const isNull = (input) => input === null;
const isUndefined = (input) => typeof input === 'undefined';
const isNullOrUndefined = (input) => isNull(input) || isUndefined(input);
const getConstructor = (input) => (!isNullOrUndefined(input) ? input.constructor : undefined);
const isObject = (input) => getConstructor(input) === Object;
const isNumber = (input) => getConstructor(input) === Number && !Number.isNaN(input);
const isString = (input) => getConstructor(input) === String;
const isBoolean = (input) => getConstructor(input) === Boolean;
const isFunction = (input) => getConstructor(input) === Function;
const isArray = (input) => Array.isArray(input);
const isInstanceOf = (input, constructor) => Boolean(input && constructor && input instanceof constructor);

export { isNull as a, isObject as b, isNullOrUndefined as c, isString as d, isArray as e, isUndefined as f, isFunction as g, isNumber as h, isInstanceOf as i, isBoolean as j };
